import React, { useState, useEffect } from 'react';
import { Typography, Button, message } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import { Html5Qrcode } from "html5-qrcode";
import AppHeader from './Header'; // Import the shared header component
import decodeBoxId from './decodeBoxId'; // Import the decodeBoxId function
import './Borrow.css'; // Import the CSS file
import './common.css'; // Import the common CSS file

const qrConfig = { fps: 10, qrbox: { width: 150, height: 150 } };
let html5QrCode;
let sessionTimeout;

const Borrow = () => {
    const { Title } = Typography;
    const navigate = useNavigate();
    const location = useLocation();
    const [userName, setUserName] = useState(sessionStorage.getItem('name'));
    const [scanData, setScanData] = useState({ userId: "", boxId: "" });
    const [decodedBoxId, setDecodedBoxId] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [isScanning, setIsScanning] = useState(false);
    const [borrowHistory, setBorrowHistory] = useState([]);

    useEffect(() => {
        const userId = sessionStorage.getItem('userId');
        setScanData(prevData => ({ ...prevData, userId }));
        resetSessionTimeout();
        window.addEventListener('mousemove', resetSessionTimeout);
        window.addEventListener('keypress', resetSessionTimeout);

        if (userId) {
            fetchBorrowHistory(userId);
        }

        return () => {
            window.removeEventListener('mousemove', resetSessionTimeout);
            window.removeEventListener('keypress', resetSessionTimeout);
        };
    }, []);

    useEffect(() => {
        if (location.state && location.state.boxId) {
            setScanData(prevData => ({ ...prevData, boxId: location.state.boxId }));
        }
    }, [location.state]);

    const resetSessionTimeout = () => {
        if (sessionTimeout) clearTimeout(sessionTimeout);
        sessionTimeout = setTimeout(handleLogout, 30 * 60 * 1000); // 30 minutes
    };

    const fetchBorrowHistory = async (userId) => {
        try {
            const response = await fetch(`https://54.178.141.189/users/${userId}/history`);
            const data = await response.json();
            setBorrowHistory(data);
        } catch (error) {
            console.error('Error fetching borrow history:', error);
        }
    };

    const handleScan = () => {
        navigate('/scan');
    };

    const handleLogin = () => {
        navigate('/login');
    };

    const handleLogout = () => {
        sessionStorage.clear();
        setUserName(null);
        navigate('/login');
    };

    const handleSubmit = async () => {
        if (scanData.userId === "" ){
            message.error("請掃學生證");
        }
        else if (scanData.boxId === "" ){
            message.error("請掃餐盒條碼 Please scan the box qrcode");
        }
        else {
            console.log(scanData);
            try {
                const response = await fetch(`https://54.178.141.189/users/${scanData.userId}/borrow`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        machineId: 1,
                        userId: scanData.userId,
                        boxId: scanData.boxId,
                        messageType: 'borrow',
                        status: 1
                    })
                });
                const data = await response.json();
                if (data.status === 1) {
                    const date = new Date();
                    setSuccessMessage(`借用成功 Box borrowed！\n${date.toLocaleDateString()}\n${date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`);
                    fetchBorrowHistory(scanData.userId); // Refresh borrow history
                } else if (data.status === -2) {
                    alert("餐盒qr code錯誤 Box qr code error"); 
                    window.location.reload();
                } else if (data.status === 0) {
                    alert("餐盒尚未歸還 Box unreturned"); 
                    window.location.reload();
                }else if (data.status === -1) {
                    alert("請先確認信箱 Please confirm email"); 
                    window.location.reload();
                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
    };

    const startScan = () => {
        if (!userName) {
            message.error("請先登入 Please login");
            return;
        }
    
        html5QrCode = new Html5Qrcode("reader");
        const qrCodeSuccessCallback = (decodedText, decodedResult) => {
            console.info(decodedResult, decodedText);
            const decodedBoxId = decodeBoxId(decodedText);
            if (decodedBoxId !== null) {
                setScanData(prevData => ({ ...prevData, boxId: decodedText }));
                setDecodedBoxId(decodedBoxId);
            } else {
                message.error("Invalid box QR code");
            }
            stopScan();
        };
        html5QrCode.start(
            { facingMode: "environment" },
            qrConfig,
            qrCodeSuccessCallback
        ).then(() => {
            setIsScanning(true);
        }).catch(err => {
            console.error(err);
        });
    };

    const stopScan = () => {
        if (html5QrCode) {
            html5QrCode.stop().then(() => {
                html5QrCode.clear();
                setIsScanning(false);
            }).catch(err => {
                console.error(err);
            });
        }
    };

    return (
        <div>
            <AppHeader userName={userName} handleLogout={handleLogout} />
            <div className="borrow-container">
            {!successMessage ? (
                <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'flex-start', height: '100vh' }}>
                    <div className="content-container-app">
                    <Title level={1} style={{ fontFamily: 'Normal', fontSize: '2.5rem', fontWeight: 'bold', textAlign: 'center' }}>臺大循環餐盒系統試辦計畫</Title>
                    <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '0.5rem' }}>NTU ECOntainer Pilot Program</p>
                    <img src="/eco-packaging.png" alt="Logo" style={{ width: '25%'}} />
                        <Title level={2} className="sub-title">借用餐盒</Title>
                        <p style={{ fontFamily: 'Normal', fontSize: '2rem', fontWeight: 'bold', textAlign: 'center', marginTop: '0rem', marginBottom: "0rem" }}>Borrow Box</p>
                        <div id="reader" className="qr-reader"></div>
                        <div className="button-container">
                            <Button onClick={startScan} disabled={isScanning} className="scan-button">
                                Start Scan
                            </Button>
                            <Button onClick={stopScan} disabled={!isScanning} className="scan-button">
                                Stop Scan
                            </Button>
                            <Title level={2} className="box-id">Box ID：{decodedBoxId}</Title>
                            <div className="action-buttons">
                                <Button type="primary" className="clear-button" onClick={e => {window.location.reload()}}>Clear</Button>
                                <Button type="primary" className="submit-button" onClick={handleSubmit}>Borrow</Button> 
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="success-message">
                    <p>{successMessage}</p>
                </div>
            )}
            </div>
        </div>
    );
};

export default Borrow;